define 'controller/WishlistController', ['jquery', 'lib/product-reviews','lib/kryptonite'], ($, reviews) ->
  class WishlistController

    constructor: (@$el) ->
      self = this

      $(window).on 'plp:new-products-loaded', ->
        self._updateWishlistActionHandler()

      @_updateWishlistActionHandler()
      @$el.find('[data-wishlist]').each () ->
        $this = $(this)
        if this.dataset.wishlist == 'true'
          self._showRemoveFromWishlistIcon $this

    _updateWishlistActionHandler: ->
      self = @
      $(@$el).off 'click', '[data-wishlist]'
      $(@$el).on 'click', '[data-wishlist]', { self: self }, self._onToggleWishlist

    _onToggleWishlist: (event) ->
      event.stopPropagation()
      event.preventDefault()

      self = event.data.self
      element = event.currentTarget
      productId = element.dataset.productId
      catId = element.dataset.catId
      if(!catId)
        params = location.search
        paramList = params.split("&");
        for string in paramList
          if string.startsWith("cat")
            catId = string.split("=")[1];
      ref = element.dataset.ref
      template = element.dataset.template
      ariaLabelAdd = $(element).data("label-add")
      ariaLabelRemove = $(element).data("label-remove")

      if element.dataset.wishlist == 'true'
        self._sendRemoveRequest productId, (data) ->
          element.dataset.wishlist = 'false'
          itemCount = data
          self._updateHeader itemCount
          self._showAddToWishlistIcon element
          self._sendRemoveDataLayer productId , ref, template
          $(element).attr("aria-pressed", "false")
          if ariaLabelAdd != ""
            $(element).attr('aria-label', ariaLabelAdd)
      else
        self._sendPutRequest productId, catId,(data) ->
          element.dataset.wishlist = 'true'
          itemCount = data
          self._updateHeader itemCount
          self._showRemoveFromWishlistIcon element
          self._sendAddDataLayer productId, ref, template
          $(element).attr("aria-pressed", "true")
          if ariaLabelRemove != ""
            $(element).attr('aria-label', ariaLabelRemove)

    _sendPutRequest: (productId , catId, onSuccess) ->
      $.kryptonite
        url: '/wishlist/api'
        method: 'PUT'
        data:
          'productId': productId
          'catId': catId
        success: onSuccess

    _sendRemoveRequest: (productId, onSuccess) ->
      $.kryptonite
        url: '/wishlist/api'
        method: 'DELETE'
        data:
          'productId': productId
        success: onSuccess

    _showAddToWishlistIcon: (root) ->
      $(root).removeClass('active')

    _showRemoveFromWishlistIcon: (root) ->
      $(root).addClass('active')

    _updateHeader: (count) ->
      elements =  $('[data-wishlistcount]')
      elements.text count

      if (count == 0)
        elements.addClass('wishlist--empty').removeClass('wishlist--withArticles')
      else
        elements.removeClass('wishlist--empty').addClass('wishlist--withArticles')

    _sendAddDataLayer: (productId, ref, template) ->
        appendix = "addToWishlist?externalKey="+productId
        if ref
          appendix += "&ref="+ref
        if template
          appendix += "&template="+template
        this._sendEvent(appendix, productId)

    _sendRemoveDataLayer:(productId, ref, template) ->

        appendix  ="removeFromWishlist?externalKey="+productId
        if ref
          appendix += "&ref="+ref
        if template
          appendix += "&template="+ template
        this._sendEvent(appendix , productId)

    _sendEvent: (appendix, prodRef) ->
      self = this
      $.ajax
        url: '/api/datalayer/event/' + appendix
        type: 'GET'
        xhrFields:
          showLoadingIndicator: false
        success: (content) ->
          if content == undefined
            return
          event = ""
          try
            event = JSON.parse(decodeURIComponent(escape(atob(content))))
          catch e
            event = JSON.parse(atob(content))
          $.ajax
            url: '/api/datalayer/event/avisData?externalKey=' + prodRef
            type: 'GET'
            xhrFields:
              showLoadingIndicator: false
            success: (data) ->
              siteId = data.siteId
              productKeys = data.concatenatedArticleRefs.split(',')
              reviews.retrieveRating siteId, productKeys, (rating) ->
                event.siteId = siteId
                event.avisRating = rating
                if event
                  dataLayer.push(event)
            failure: ->
              if event
                dataLayer.push(event)